import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
    SimpleItem,
    GroupItem,
    Label
} from 'devextreme-react/form';
import 'devextreme-react/text-area';
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../../UserInfo";
import { inserirOuAtualizar, criarContasBancariasDs, criarAgentesRecebedoresDs } from "../../DataSources";
import ShowError from "../../AppServices";

let _contaBancariaCorrente;


const template = {
    "id": undefined,
    "ret": "",
    "prefeituraId": undefined,
    "agenteRecebedorId": undefined,
    "agenteRecebedor": undefined,
    "agencia": "",
    "agenciaDv": "",
    "agenciaComDv": undefined,
    "conta": "",
    "contaDv": "",
    "contaComDv": undefined,
    "carteira": "",
    "variacaoCarteira": "",
    "tipoCarteira": undefined,
    "formaCadastramento": undefined,
    "tipoImpresao": undefined,
    "codigoCedente": "",
    "codigoCedenteDv": "",
    "habilitarBoletos": undefined,
    "convenio": "",
    "contrato": "",
    "tipoArquivo": undefined,
    "padraoNomeArquivoRetorno": undefined
};


export default class ContaBancariaForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        template.prefeituraId = UserInfo.getPrefeitura();
        this.contaBancariaDs = criarContasBancariasDs();

        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);
        this.saidaProgramada = false;
        console.log('params.id:', this.props.match.params.id);
    }

    componentDidMount() {
        if (this.props.match.params.id !== undefined) {
            console.log('params.id:', this.props.match.params.id);
            this.contaBancariaDs.byKey(this.props.match.params.id)
                .then(data => {
                    if (data == undefined) {
                        notify("Registro não encontrado.", "error");
                        this.props.history.push("/contasbancarias");
                    }
                    this.setState(data);
                })
                .catch(error => {
                    ShowError(error.response.data);
                    notify(error, "error", 2000);
                    this.props.history.goBack();
                });

        } if (this.props.match.params.id === undefined){
            this.setState({...template});
        }
    }

    render() {

        const agentesRecebedoresOptions = {
            editorType: "dxSelectBox",
            searchEnabled: true,
            dataSource: criarAgentesRecebedoresDs(),
            valueExpr: "id",
            displayExpr: "descricao"
        }

        const tipoCarteiraOptions = [
            { id: "0", descricao: "Não Definido" },
            { id: "1", descricao: "Cobrança Simples" },
            { id: "2", descricao: "Cobrança Vinculada" },
            { id: "3", descricao: "Cobrança Caucionada" },
            { id: "4", descricao: "Cobrança Descontada" },
            { id: "5", descricao: "Cobrança Vendor" },
        ];

        const formaCadastramentoOptions = [
            { id: "0", descricao: "Não Definido" },
            { id: "1", descricao: "Com Registro" },
            { id: "2", descricao: "Sem Registro" },
            { id: "3", descricao: "Débito Automático" },
        ];

        const tipoImpresaoOptions = [
            { id: "0", descricao: "Não Definido" },
            { id: "1", descricao: "Banco" },
            { id: "2", descricao: "Empresa" },
            { id: "3", descricao: "Banco Pré-Emite Cliente Complementa" },
            { id: "4", descricao: "Banco Reemite" },
            { id: "5", descricao: "Banco Não Reemite" },
            { id: "7", descricao: "Banco Emitente Aberta" },
            { id: "8", descricao: "Banco Emitente Auto-Envolopável" },
        ];

        const tipoArquivoOptions = [
            { id: "0", descricao: "CNAB 240" },
            { id: "1", descricao: "CNAB 400" },
        ];

        const escolherTipoCarteira = {
            editorType: "dxSelectBox",
            searchEnabled: false,
            dataSource: tipoCarteiraOptions,
            valueExpr: "id",
            displayExpr: "descricao"
        }

        const escolherformaCadastro = {
            editorType: "dxSelectBox",
            searchEnabled: false,
            dataSource: formaCadastramentoOptions,
            valueExpr: "id",
            displayExpr: "descricao"
        }

        const escolherTipoEmpresao = {
            editorType: "dxSelectBox",
            searchEnabled: false,
            dataSource: tipoImpresaoOptions,
            valueExpr: "id",
            displayExpr: "descricao"
        }

        const escolherTipoArquivo = {
            editorType: "dxSelectBox",
            searchEnabled: false,
            dataSource: tipoArquivoOptions,
            valueExpr: "id",
            displayExpr: "descricao"
        }

        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <Form formData={this.state} colCount={2}>
                        <GroupItem caption="INFORMAÇÕES DE CONTA" colSpan={2} colCount={2}>
                            <SimpleItem
                                dataField={'agenteRecebedorId'}
                                editorType={"dxLookup"}
                                editorOptions={agentesRecebedoresOptions}>
                                <Label text="Agente Recebedor" />
                            </SimpleItem>
                            <SimpleItem dataField={'ret'}>
                                <Label text="RET" />
                            </SimpleItem>
                            <SimpleItem dataField={'agencia'}>
                                <Label text="Agência" />
                            </SimpleItem>
                            <SimpleItem dataField={'agenciaDv'}>
                                <Label text="Digito da Agência" />
                            </SimpleItem>
                            <SimpleItem dataField={'conta'}>
                                <Label text="Conta" />
                            </SimpleItem>
                            <SimpleItem dataField={'contaDv'}>
                                <Label text="Dígito da Conta" />
                            </SimpleItem>
                            <SimpleItem dataField={'codigoCedente'}>
                                <Label text="Código do Cedente" />
                            </SimpleItem>
                            <SimpleItem dataField={'codigoCedenteDv'}>
                                <Label text="Dígito do Cedente" />
                            </SimpleItem>
                        </GroupItem>
                        <GroupItem caption="OUTRAS INFORMAÇÕES" colSpan={2} colCount={2}>
                            <SimpleItem dataField={'carteira'}>
                                <Label text="Carteira" />
                            </SimpleItem>
                            <SimpleItem dataField={'variacaoCarteira'}>
                                <Label text="Variação da Carteira" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={'tipoCarteira'}
                                editorType={"dxLookup"}
                                editorOptions={escolherTipoCarteira}>
                                <Label text="Tipo da Carteira" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={'formaCadastramento'}
                                editorType={"dxLookup"}
                                editorOptions={escolherformaCadastro}>
                                <Label text="Forma de Cadastramento" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={'tipoImpresao'}
                                editorType={"dxLookup"}
                                editorOptions={escolherTipoEmpresao}>
                                <Label text="Tipo de Impressão" />
                            </SimpleItem>
                            <SimpleItem dataField={'convenio'}>
                                <Label text="Convênio" />
                            </SimpleItem>
                            <SimpleItem dataField={'contrato'}>
                                <Label text="Contrato" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={'tipoArquivo'}
                                editorType={"dxLookup"}
                                editorOptions={escolherTipoArquivo}>
                                <Label text="Tipo de Arquivo" />
                            </SimpleItem>
                            <SimpleItem dataField={'habilitarBoletos'} editorType={"dxCheckBox"}>
                                <Label text="Habilitar Boletos" />
                            </SimpleItem>
                        </GroupItem>
                        <GroupItem colCount={6}>
                            <ButtonItem horizontalAlignment={'left'} buttonOptions={{ type: "success", text: "Salvar", onClick: this.ok }} />
                            <ButtonItem horizontalAlignment={'left'} buttonOptions={{ type: "warn", text: "Cancelar", onClick: this.cancel }} />
                        </GroupItem>
                    </Form>
                </div>
            </React.Fragment>
        );

    }

    ok() {
        const entidade = this.state;
        inserirOuAtualizar(this.contaBancariaDs, entidade)
            .then(function () {
                _contaBancariaCorrente = undefined;
                notify("Conta Bancária cadastrado com sucesso.", "success");
                this.props.history.goBack();
            }.bind(this))
            .catch(function (error) {
                ShowError(error.response.data);
                notify(error, "error", 2000);
            });
    }

    cancel() {
        _contaBancariaCorrente = undefined;
        notify("Operação cancelada", "warning");
        this.props.history.goBack();
    }
}